import { isEmpty } from 'lodash'

export const isLogged = ({ isLogged }) => isLogged
export const currentUser = ({ user }) => user
export const seller = ({ seller }) => seller
export const admUser = ({ admUser }) => admUser
export const cust = ({ cust }) => cust
export const userToken = ({ userToken }) => userToken
export const customerToken = ({ customerToken }) => customerToken
export const currentRoute = ({ currentRoute }) => currentRoute
export const prevRoute = ({ prevRoute }) => prevRoute
export const isPopup = ({ isPopup }) => isPopup
export const customerLogged = ({ customerToken }) => !isEmpty(customerLogged)



// WEBPACK FOOTER //
// ./src/app/pages/auth/vuex/getters.js